import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useService from "../../../Hooks/useService";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult, { Loaders, } from "../../../UI/ServiceResult/ServiceResult";
import CustomCard from "../../../UI/CustomCard/CustomCard";
import InfoItems from "../../../UI/InfoItems/InfoItems";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import AreaOfStudyService from "../../../../Services/AreaOfStudy.service";
import { getAreaOfStudyEditPath, getAreaOfStudyIndexPath, } from "./AreaOfStudyRoutes";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import DateService from "../../../../Services/Shared/Date.service";
import PageTitle from "../../../UI/PageTitle/PageTitle";
const AreaOfStudyDetail = () => {
    const params = useParams();
    const id = parseInt(params.id, 10);
    const [areaOfStudyState, loadAreaOfStudy] = useService(AreaOfStudyService.get);
    useEffect(() => {
        if (id) {
            loadAreaOfStudy(id);
        }
    }, [loadAreaOfStudy, id]);
    return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex", children: _jsx(Link, { to: getAreaOfStudyEditPath(id), title: "Edit", tabIndex: -1, children: _jsx(SecondaryNavButton, { icon: "pencil-alt", label: "Edit", title: "Edit", iconType: "fas" }) }) }), children: _jsx(ContentLayout, { paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(ServiceResult, { loader: Loaders.overlay(), state: areaOfStudyState, children: (areaOfStudy) => (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "pb-2", children: [_jsx(Link, { to: getAreaOfStudyIndexPath(), className: "text-decoration-none pr-2", title: "Back to areas of study", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), areaOfStudy.name] }), _jsx(CustomCard, { title: "Details", className: "mt-3", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 1, numColumnsMd: 1, numColumnsSmAndSmaller: 1, items: [
                                        {
                                            label: "ID",
                                            value: areaOfStudy.id,
                                        },
                                        {
                                            label: "Source System ID",
                                            value: areaOfStudy.srcSystemId,
                                        },
                                        {
                                            label: "Active",
                                            value: _jsx(BooleanDisplay, { val: areaOfStudy.active }),
                                        },
                                        {
                                            label: "Area Of Study Type",
                                            value: areaOfStudy.areaOfStudyType.name,
                                        },
                                        {
                                            label: "SIS Import Created Date",
                                            value: DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportCreatedDate),
                                        },
                                        {
                                            label: "SIS Import Modified Date",
                                            value: DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportModifiedDate),
                                        },
                                    ] }) }) })] })) }) }) }));
};
export default AreaOfStudyDetail;
